import { Component, OnInit, ViewChild } from '@angular/core';
import { NuevoUsuarioViewModel } from '../../models/viewmodels/UsuarioViewmodel';
import { ClienteViewModel } from '../../models/viewmodels/ClienteViewModel';
import { UsuarioService } from '../../services/usuario.service';
import { ClienteService } from '../../services/cliente.service';
import { FormControl } from '@angular/forms';

import { DoubleBounceComponent } from '../../shared/spinners/double-bounce/double-bounce.component'
import { CustomAlertComponent } from '../../shared/custom-alert/custom-alert.component';

import { Router, ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-registro-usuario',
  templateUrl: './registro-usuario.component.html',
  styleUrls: ['./registro-usuario.component.scss']
})
export class RegistroUsuarioComponent implements OnInit {

  usuario: NuevoUsuarioViewModel = new NuevoUsuarioViewModel();
  private cliente: ClienteViewModel = new ClienteViewModel();

  alert: any = {
    tipo: "success",
    titulo: "",
    mensaje: "",
    visible: false
  }

  private sub: any;

  errores = new Array();

  @ViewChild(DoubleBounceComponent)
  spinner: DoubleBounceComponent;

  @ViewChild(CustomAlertComponent)
  private alertComponent: CustomAlertComponent;

  constructor(private usuarioService: UsuarioService, private clienteService: ClienteService,
    private router: Router, private route: ActivatedRoute) {
    this.sub = this.route.params.subscribe(params => {
      this.cliente.id = params['id'];
      if (!this.cliente.id) {
        this.router.navigate(['login']);
        return;
      }
      this.usuario.clientes = new Array<ClienteViewModel>();
      this.usuario.clientes.push(this.cliente);
      this.clienteService.obtenerEmail(this.cliente.id).subscribe(res => {
        this.usuario.userName = res.text().replace(/\"/g, '');
        if (!this.usuario.userName) {
          this.router.navigate(['login']);
          return;
        }
      })
    });
  }

  ngOnInit() {
    this.spinner.isRunning = false;
  }

  onSubmit() {
    this.spinner.isRunning = true;
    this.alert.visible = false;
    this.usuario.recibeComprobantes = true;
    this.usuarioService.guardar(this.usuario)
      .map(result => {
        this.alert.visible = true;
        this.alert.titulo = "Nuevo usuario";
        if (result.status == 201) {
          this.router.navigate(['login']);
        } else {
          this.alert.tipo = "danger"
          this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo."
        }
        this.alertComponent.setType(this.alert.tipo);
        this.spinner.isRunning = false;
      })
      .subscribe(data => {

      }, error => {        
        var json = error.json();
        this.spinner.isRunning = false;
        this.alert.visible = true;
        this.alert.titulo = "Nuevo usuario";
        this.alert.tipo = "danger"
        this.alertComponent.setType(this.alert.tipo);
        this.alert.mensaje = "El usuario no se ha podido crear. Por favor vuelva a intentarlo.";
        if(json.message){
          var errores = json.message.replace(/\"/g, '').replace(/\[/g, '').replace(/\]/g, '').split(',');
          this.errores = errores;
        } else if (json.modelState) {
          for (var key in json.modelState) {
            if (json.modelState[key].length == 1) {
              this.errores.push(json.modelState[key]);
            } else {
              for (var i = 0; i < json.modelState[key].length; i++) {
                this.errores.push(json.modelState[key][i]);
              }
            }
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/usuarios/registro-usuario/registro-usuario.component.ts